'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import I18n from 'I18n';
import { omit } from 'rich-text-lib/utils/iterables';
import AlignmentMenu from 'rich-text-lib/components/formatting/AlignmentMenu';
import { i18nNameSpace } from '../../constants/hsformatting';
import { jsx as _jsx } from "react/jsx-runtime";
export default class TinyMceAlignMenu extends Component {
  constructor(props) {
    super(props);
    this.handleFormatChange = this.handleFormatChange.bind(this);
    this.state = {
      alignment: props.getlastAlign()
    };
  }
  componentDidMount() {
    this.props.editor.on(this.formatEvents.join(' '), this.handleFormatChange);
  }
  componentWillUnmount() {
    this.props.editor.off(this.formatEvents.join(' '), this.handleFormatChange);
  }
  handleFormatChange({
    format,
    isActive
  }) {
    const {
      alignOptions
    } = this.props;
    const matched = Object.keys(alignOptions).find(option => {
      return format.match(alignOptions[option]);
    });
    const alignment = alignOptions[matched];
    if (isActive) {
      this.setState({
        alignment
      });
    } else if (this.state.alignment === alignment) {
      this.setState({
        alignment: alignOptions.LEFT
      });
    }
  }
  get formatEvents() {
    return this.props.formats.map(format => `FormatChanged:${format}`);
  }
  render() {
    this.props.setlastAlign(this.state.alignment);
    return /*#__PURE__*/_jsx(AlignmentMenu, Object.assign({}, this.state, omit(Object.keys(TinyMceAlignMenu.propTypes), this.props), {
      tooltip: I18n.text(`${i18nNameSpace}.tooltip.align`),
      alignOptions: this.props.alignOptions
    }));
  }
}
TinyMceAlignMenu.propTypes = {
  editor: PropTypes.object.isRequired,
  alignOptions: PropTypes.shape({
    CENTER: PropTypes.string,
    LEFT: PropTypes.string,
    RIGHT: PropTypes.string,
    FULL: PropTypes.string
  }),
  formats: PropTypes.arrayOf(PropTypes.string).isRequired,
  setlastAlign: PropTypes.func.isRequired,
  getlastAlign: PropTypes.func.isRequired
};